import axios from "axios";
import deployMarketAppPage from "scenes/Application/DeployMarketApp/DeployMarketAppPage";

// const
const REDIRECT_TO_APPLICATION_MARKET_VIEW = "applicationMarketView/REDIRECT_TO_APPLICATION_MARKET_VIEW";
const APPLICATION_MARKET_VIEW_STORE_APPLICATION = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APPLICATION";
// const APPLICATION_MARKET_VIEW_STORE_APP_VERSIONS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APP_VERSIONS";
const APPLICATION_MARKET_VIEW_STORE_VERSIONS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_VERSIONS";
const APPLICATION_MARKET_VIEW_STORE_VERSION = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_VERSION";
const APPLICATION_MARKET_VIEW_STORE_APP_VERSION = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APP_VERSION";
// const APPLICATION_MARKET_VIEW_STORE_APP_PLANS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APP_PLANS";
const APPLICATION_MARKET_VIEW_STORE_APP_PERIODS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APP_PERIODS";
const APPLICATION_MARKET_VIEW_STORE_APP_USER_CONCURRENTS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_APP_USER_CONCURRENTS";
const APPLICATION_MARKET_VIEW_UPDATE_DATA = "applicationMarketView/APPLICATION_MARKET_VIEW_UPDATE_DATA";
const APPLICATION_MARKET_VIEW_TOGGLE_LOADING = "applicationMarketView/APPLICATION_MARKET_VIEW_TOGGLE_LOADING";
const APPLICATION_MARKET_VIEW_STORE_RELATED_APPLICATIONS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_RELATED_APPLICATIONS";
const APPLICATION_MARKET_VIEW_STORE_ALL_COMPATIBILITIES = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_ALL_COMPATIBILITIES";
const APPLICATION_MARKET_VIEW_STORE_VERSION_COMPATIBILITIES = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_VERSION_COMPATIBILITIES";
const APPLICATION_MARKET_VIEW_STORE_CHILD_APPLICATION_VERSIONS = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_CHILD_APPLICATION_VERSIONS";
const APPLICATION_MARKET_VIEW_STORE_SUBSCRIBE = "applicationMarketView/APPLICATION_MARKET_VIEW_STORE_SUBSCRIBE";

// reducer
export const applicationMarketView = (state = {

  loading: false,
  visible: false,
  index: 0,

  userId: "",
  companyId: "",

  subscribeId: "",
  applicationId: "",
  application: {
    name: "",
    logo: "",
    createCompanyName: "",
    createUserName: "",
    createDate: "",
    parentCategory: [{id: "", code: "", name: ""}],
    category: [{id: "", code: "", name: ""}],
    childApplicationList: [],
    resources: [],
  },
  relatedApplications: [{
    name: "",
    logo: "",
    createCompanyName: "",
    createUserName: "",
    createDate: "",
    parentCategory: [{id: "", code: "", name: ""}],
    category: [{id: "", code: "", name: ""}],
  }],

  versions: [],
  version: [],
  screenshots: [],
  screenshot: "",

  appPlans: [],
  isPeriod: false,
  appPeriods: [],
  isUserConcurrent: false,
  appUserConcurrents: [],
  appPlanId: "",
  appPlanCode: "",
  periodCost: 0.00,
  periods: 1,
  periodDiscount: 1.0,
  userCost: 0.00,
  users: 1,
  userDiscount: 1.0,
  cost: 0.00,
  agreement: false,

  allCompatibilities: [],
  versionCompatibilities: [],
  childApplicationVersions: [],
  selectedApplication: [],
  selectedVersion: [],
  selectedDisabled: [],

  parentVersion: {},
  parentVersionText: "",
  deployPlanCode: "",
  isCompatible: true,

  isPermanent: false,
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_APPLICATION_MARKET_VIEW:
      return {
        ...state,
        applicationId: action.data
      };
    case APPLICATION_MARKET_VIEW_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_MARKET_VIEW_STORE_APPLICATION:
      return {
        ...state,
        loading: false,
        visible: false,
        index: 0,
        isPeriod: false,
        isUserConcurrent: false,
        appPlanId: "",
        periodCost: 0.00,
        periods: 1,
        periodDiscount: 1.0,
        userCost: 0.00,
        users: 1,
        userDiscount: 1.0,
        cost: 0.00,
        agreement: false,
        applicationId: action.data.id,
        application: action.data,
        selectedApplication: [action.data.id],

        selectedVersion: action.data.childApplicationList.map(d => {
          return ""
        }),

        // selectedDisabled: action.data.childApplicationList.map(application => {
        //   return !!application.dependApplicationList.map(dependApplication => {
        //     console.log(state.selectedApplication, state.selectedVersion);
        //     return state.selectedApplication.indexOf(dependApplication.dependApplicationId) > -1;
        //   }).filter(f => {
        //     return f === false
        //   }).length
        // }),

        // applicationVersions: action.data.applicationVersionList,
        // applicationVersion: action.data.applicationVersionList.length > 0 ? action.data.applicationVersionList[0] : [],
        // applicationScreenshots: action.data.applicationVersionList.length > 0 ? action.data.applicationVersionList[0].applicationVersionScreenshots : [],
        // appPlans: action.data.applicationPlanList,
        // appPeriods: action.data.applicationVersionList.length > 0 ? action.data.applicationVersionList[0] : [],
        // appUserConcurrents: action.data.applicationVersionList.length > 0 ? action.data.applicationVersionList[0] : [],
      };
    // case APPLICATION_MARKET_VIEW_STORE_APP_VERSIONS:
    //   return {
    //     ...state,
    //     applicationVersions: action.data
    //   };
    case APPLICATION_MARKET_VIEW_STORE_VERSIONS:
      return {
        ...state,
        versions: action.data,
      };
    case APPLICATION_MARKET_VIEW_STORE_VERSION:
      return {
        ...state,
        version: action.data,
        screenshots: action.data.screenshots,
        screenshot: "",
      };
    case APPLICATION_MARKET_VIEW_STORE_APP_VERSION: {
      let selectedApplication = [state.application.id];
      let selectedVersion = state.application.childApplicationList.map(d => {
        return ""
      });
      let selectedDisabled = state.application.childApplicationList.map(application => {
        return !!application.dependApplicationList.map(dependApplication => {
          return selectedApplication.indexOf(dependApplication.dependApplicationId) > -1;
        }).filter(f => {
          return f === false
        }).length
      });

      return {
        ...state,
        applicationVersion: action.data,
        applicationScreenshots: action.data.applicationVersionScreenshots,
        selectedApplication: selectedApplication,
        selectedVersion: selectedVersion,
        selectedDisabled: selectedDisabled,
      };
    }
    case APPLICATION_MARKET_VIEW_STORE_APP_PERIODS:
      return {
        ...state,
        appPeriods: action.data,
      };
    case APPLICATION_MARKET_VIEW_STORE_APP_USER_CONCURRENTS:
      return {
        ...state,
        appUserConcurrents: action.data,
      };
    case APPLICATION_MARKET_VIEW_STORE_RELATED_APPLICATIONS:
      return {
        ...state,
        relatedApplications: action.data
      };
    // case APPLICATION_MARKET_VIEW_STORE_VERSION_COMPATIBILITIES:
    //   return {
    //     ...state,
    //     versionCompatibilities: action.data,
    //   };
    case APPLICATION_MARKET_VIEW_STORE_CHILD_APPLICATION_VERSIONS:
      return {
        ...state,
        childApplicationVersions: action.data,
      };
    case APPLICATION_MARKET_VIEW_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case APPLICATION_MARKET_VIEW_STORE_SUBSCRIBE:
      return {
        ...state,
        subscribeId: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：application.id、application.name
 */
export function redirectToApplicationMarketViewPage(applicationId) {
  return {
    type: REDIRECT_TO_APPLICATION_MARKET_VIEW,
    data: applicationId
  };
}

/**
 * update data based on user input
 */
export const updateApplicationMarketViewData = (data) => {
  return {
    type: APPLICATION_MARKET_VIEW_UPDATE_DATA,
    data: data
  }
};

/**
 * check application and get appVersions
 */
export const initApplication = (data) => (dispatch) => {

  dispatch(updateApplicationMarketViewData({
    name: "companyId",
    value: data.enterpriseCode
  }));

  let applicationId = data.applicationId;
  if (applicationId !== null && applicationId !== undefined && applicationId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-application/getApplication/${applicationId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeApplication(response.data));
          // if (response.data.childApplicationList.length > 0) {//主应用
          //   //过滤查询子应用版本集合
          //   let majorVersion = response.data.majorVersionList[0].majorVersion;
          //   axios.get(`/api-application/getChildApplicationVersionsByParentApplicationAndMajorVersion/${applicationId}/${majorVersion}`, {contentType: "application/json"}).then(
          //     response => {
          //       if (response.data) {
          //         dispatch(storeChildApplicationVersions(response.data));
          //         dispatch(toggleLoading(false));
          //       }
          //     }
          //   );
          // } else if (response.data.isModule && data.enterpriseCode !== "") {//子应用
          //   let parentVersions = response.data.parentApplication.applicationVersionList;
          //   //查询主应用的部署版本
          //   axios.get(`/api-tenant/app/getVersionIdByApplicationIdAndEnterpriseCode/?enterpriseCode=${data.enterpriseCode}&applicationId=${response.data.parentApplication.id}`, {contentType: "application/json"}).then(
          //     response => {
          //       if (response.data) {
          //         let deployMainApp = response.data;
          //         let parentVersion = parentVersions.find(parentVersion => {
          //           return parentVersion.id === deployMainApp.versionId;
          //         });
          //         dispatch(updateApplicationMarketViewData({
          //           name: "parentVersion",
          //           value: parentVersion
          //         }));
          //         dispatch(updateApplicationMarketViewData({
          //           name: "parentVersionText",
          //           value: `已部署${parentVersion.version}`
          //         }));
          //         dispatch(updateApplicationMarketViewData({
          //           name: "deployPlanCode",
          //           value: deployMainApp.planCode
          //         }));
          //         //过滤子应用版本
          //         // axios.get(`/api-application/getVersionCompatibilityByParentVersionId/${deployMainApp.versionId}`, {contentType: "application/json"}).then(
          //         //   response => {
          //         //     if (response.data) {
          //         //       let versionCompatibilityList = response.data.filter(versionCompatibility => {
          //         //         return versionCompatibility.childApplication.id = applicationId;
          //         //       });
          //         //       if (versionCompatibilityList.length > 0) {
          //         //         dispatch(storeVersionCompatibilities(versionCompatibilityList));
          //         //         if (versionCompatibilityList.find(compatibility => {
          //         //             return compatibility.childVersion.id === versionId;
          //         //           })) {
          //         //           dispatch(updateApplicationMarketViewData({
          //         //             name: "isCompatible",
          //         //             value: true
          //         //           }));
          //         //         } else {
          //         //           dispatch(updateApplicationMarketViewData({
          //         //             name: "isCompatible",
          //         //             value: false
          //         //           }));
          //         //         }
          //         //       } else {
          //         //         dispatch(updateApplicationMarketViewData({
          //         //           name: "isCompatible",
          //         //           value: false
          //         //         }));
          //         //       }
          //         //     }
          //         //   }
          //         // );
          //         dispatch(toggleLoading(false));
          //       } else {
          //         //未查到部署记录
          //         dispatch(updateApplicationMarketViewData({
          //           name: "parentVersion",
          //           value: {}
          //         }));
          //         dispatch(updateApplicationMarketViewData({
          //           name: "parentVersionText",
          //           value: "未部署"
          //         }));
          //         dispatch(updateApplicationMarketViewData({
          //           name: "deployPlanCode",
          //           value: ""
          //         }));
          //         dispatch(updateApplicationMarketViewData({
          //           name: "isCompatible",
          //           value: false
          //         }));
          //       }
          //     }
          //   );
          // } else {
          //   //普通应用，不需要套件处理数据
          //   dispatch(updateApplicationMarketViewData({
          //     name: "parentVersion",
          //     value: {}
          //   }));
          //   dispatch(updateApplicationMarketViewData({
          //     name: "parentVersionText",
          //     value: ""
          //   }));
          //   dispatch(updateApplicationMarketViewData({
          //     name: "deployPlanCode",
          //     value: ""
          //   }));
          //   dispatch(updateApplicationMarketViewData({
          //     name: "isCompatible",
          //     value: true
          //   }));
          // }
          let parentCategoryId = response.data.parentCategory.id;
          //相关应用(按一级类别搜索)
          axios.get(`/api-application/getApplicationByParentCategory?parentCategoryId=${parentCategoryId}&applicationId=${applicationId}`, {contentType: "application/json"}).then(
            response => {
              if (response.data) {
                dispatch(storeRelatedApplications(response.data));
                dispatch(toggleLoading(false));
              }
            }
          );
        } else {
          dispatch(toggleLoading(false));
          // browserHistory.push("/appMarket");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    // browserHistory.push("/appMarket");
  }
};

/**
 * store application
 */
export const storeApplication = (application) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_APPLICATION,
    data: application
  }
};

/**
 * get all version
 */
export const getVersions = (applicationId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getVersionByApplicationId/${applicationId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeVersions(response.data));
        if (response.data.length > 0) {
          dispatch(changeAppVersion({id: response.data[0].id}));
        }
      }
    }
  );
};

/**
 * store all version
 */
export const storeVersions = (versions) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_VERSIONS,
    data: versions
  }
};

export const changeAppVersion = (data) => (dispatch) => {

  let versionId = data.id;
  if (versionId !== null && versionId !== undefined && versionId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-application/getVersionById/${versionId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeVersion(response.data));
          // if (data.application.childApplicationList.length > 0) {//主应用
          //   //过滤查询子应用版本集合
          //   let majorVersion = response.data.majorVersion;
          //   axios.get(`/api-application/getChildApplicationVersionsByParentApplicationAndMajorVersion/${data.application.id}/${majorVersion}`, {contentType: "application/json"}).then(
          //     response => {
          //       if (response.data) {
          //         dispatch(storeChildApplicationVersions(response.data));
          //         dispatch(toggleLoading(false));
          //       }
          //     }
          //   );
          // }
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
        }
      }
    );
  }
};

/**
 * store all version
 */
export const storeVersion = (version) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_VERSION,
    data: version
  }
};

/**
 * store Subscribe
 */
export const storeSubscribe = (subscribe) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_SUBSCRIBE,
    data: subscribe
  }
};

/**
 * store related applications
 */
export const storeRelatedApplications = (relatedApplications) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_RELATED_APPLICATIONS,
    data: relatedApplications
  }
};

// /**
//  * store related applications
//  */
// export const storeVersionCompatibilities = (versionCompatibilities) => {
//   return {
//     type: APPLICATION_MARKET_VIEW_STORE_VERSION_COMPATIBILITIES,
//     data: versionCompatibilities
//   }
// };

/**
 * store related applications
 */
export const storeChildApplicationVersions = (childApplicationVersions) => {
  return {
    type: APPLICATION_MARKET_VIEW_STORE_CHILD_APPLICATION_VERSIONS,
    data: childApplicationVersions
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_MARKET_VIEW_TOGGLE_LOADING,
    data: show
  }
};
/**
 * get Subscribe
 */
export const getSubscribe = (data) => (dispatch) => {

  dispatch(updateApplicationMarketViewData({
    name: "userId",
    value: data.subscribeUserId
  }));
  if (data.subscribeUserId !== "") {
    axios({
      method: "POST",
      url: `/api-application/getApplicationSubscribe`,
      contentType: "application/json",
      withCredentials: true,
      data: {
        "type": {"code": "1"},
        "subscribeUserId": data.subscribeUserId,
        "application": {id: data.applicationId},
      },
    }).then(
      response => {
        if (response.status === 200 && response.data) {
          dispatch(storeSubscribe(response.data));
        } else {
          dispatch(storeSubscribe(""));
        }
      }
    );
  } else {
    dispatch(storeSubscribe(""));
  }
};


/**
 * submit subscribe
 */
export const submitSubscribe = (data) => (dispatch) => {
  axios({
    method: "POST",
    url: `/api-application/submitSubscribe`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      "type": {"code": "1"},
      "subscribeDate": data.subscribeDate,
      "subscribeUserId": data.subscribeUserId,
      "subscribeUserName": data.subscribeUserName,
      // "subscribeCompanyId": data.subscribeCompanyId,
      // "subscribeCompanyName": data.subscribeCompanyName,
      "application": {id: data.applicationId},
      "enabled": true,

    },
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(storeSubscribe(response.data));
        message.success("订阅成功");
      }
    }
  );
};

/**
 * submit unSubscribe
 */
export const submitUnSubscribe = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: `/api-application/submitUnSubscribe`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.subscribeId,
    },
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(storeSubscribe(""));
        message.success("取消订阅成功");
      }
    }
  );
};

export const redirectToDeployMarketAppPage = (data) => (dispatch) => {
  axios(`/api-user/users?userId=${data.userId}`).then(
    response => {
      axios({
        method: "POST",
        url: `/api-account/checkBalance`,
        contentType: "application/json",
        data: {
          applicationId: data.applicationId,
          versionId: data.versionId,
          planId: data.planId,
          periods: data.periods,
          users: data.users,
          cost: data.cost,
          userId: data.userId,
          enterpriseId: data.companyId,
          isPermanent: data.isPermanent,
          account: response.data.account,
        },
      }).then(
        response => {
          if (response.status === 200) {
            dispatch(deployMarketAppPage());
      }
    }
  );
})};
